module.exports = __webpack_public_path__ + "static/media/bike3d.f0da9b93.jpg";